import { render, staticRenderFns } from "./JournalReturnMR.vue?vue&type=template&id=2e25acd5"
import script from "./JournalReturnMR.vue?vue&type=script&lang=js"
export * from "./JournalReturnMR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports